import http from "../common/services/httpService";
import { AxiosResponse } from "axios";

import { WillHistoryPreviewDto, WillInputDto, WillPreviewDto, WillSearchResultDto } from "../interfaces/Will";
import { stringifyBgToIso } from "../common/utils/dateTime";

const apiEndpoint = "/will";

const getWillsAsync = async (query: string): Promise<AxiosResponse<Array<WillSearchResultDto>>> => {
  return await http.get<Array<WillSearchResultDto>>(`${apiEndpoint}?${query}`);
};

const getWillsCountAsync = async (query: string): Promise<AxiosResponse<number>> => {
  return await http.get<number>(`${apiEndpoint}/count?${query}`);
};

const getWillAsync = async (id: number): Promise<AxiosResponse<WillPreviewDto>> => {
  return await http.get<WillPreviewDto>(`${apiEndpoint}/${id}`);
};

const addWillAsync = async (model: WillInputDto): Promise<AxiosResponse<WillInputDto>> => {
  return await http.post<WillInputDto>(apiEndpoint, model);
};

const updateWillAsync = async (model: WillInputDto): Promise<AxiosResponse<WillInputDto>> => {
  return await http.put<WillInputDto>(`${apiEndpoint}/${model.willId}`, model);
};

const getWillHistoryAsync = async (id: number): Promise<AxiosResponse<WillHistoryPreviewDto>> => {
  return await http.get<WillHistoryPreviewDto>(`${apiEndpoint}/history/${id}`);
};

const getWillIdByYearAsync = async (
  userId: number,
  registrationNumber: number,
  issueDate: Date
): Promise<AxiosResponse<number | null>> => {
  return await http.get<number | null>(
    `${apiEndpoint}/idByYear?userId=${userId}&registrationNumber=${registrationNumber}&issueDate=${stringifyBgToIso(
      issueDate
    )}`
  );
};

export default {
  getWillsAsync,
  getWillsCountAsync,
  getWillAsync,
  addWillAsync,
  updateWillAsync,
  getWillHistoryAsync,
  getWillIdByYearAsync,
};
